import * as React from "react";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AccountsConversionTable } from "../../Common/ConvertCappedToFlexi/AccountsConversionTable";
import { ImportantInformation } from "../../Common/ConvertCappedToFlexi/ImportantInformation";
import { AdviserDeclaration } from "../../Common/ConvertCappedToFlexi/AdviserDeclaration";
import { convertToFlexiStepperName, ReviewStepInformationText } from "../Resource/Content";

interface IReviewProps extends IProcessComponentProps {
    onClearError: VoidFunction;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <h2 className="mb-18">
                    <span>{convertToFlexiStepperName.review}</span>
                </h2>
                <ImportantInformation
                    data={data}
                    onChange={(v) => {}}
                    onRef={(ref) => this.appendChild(ref)}
                ></ImportantInformation>
                <AccountsConversionTable
                    data={data}
                    onChange={() => onChange({ })}
                    onRef={(ref) => this.appendChild(ref)}
                    isReviewStep={true}
                ></AccountsConversionTable>
                <Alert alertType={AlertType.Warning} message={ReviewStepInformationText} />
                <hr />
                <AdviserDeclaration
                    data={data}
                    onChange={(v) => {}}
                    onRef={(ref) => this.appendChild(ref)}
                ></AdviserDeclaration>
            </>
        );
    }
}
